module.exports = __webpack_public_path__ + "img/qld_police_logo.1fef4caa.png";